import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '@app/shared/services/authentication.service';
import { UserAuthority } from '@app/domain/model/user-authority';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaperReportComponent } from '@app/feature/admin/quick-add/paper-report/paper-report.component';
import { PaperCreditComponent } from '@app/feature/admin/quick-add/paper-credit/paper-credit.component';

/**
 * Top navigation component.
 */
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {

  constructor(private authenticator: AuthenticationService,
              private modalService: NgbModal,
              private router: Router) {
  }

  isLoggedIn(): boolean {
    return this.authenticator.isLoggedIn();
  }

  hasAuthority(authority: string): boolean {
    return this.authenticator.getCurrentUser() ? this.authenticator.getCurrentUser().hasAuthority(UserAuthority.fromString(authority)) : false;
  }

  startsWith(prefix: string) {
    const currentURL = this.router.routerState.snapshot.url;
    return 0 === currentURL.indexOf(prefix);
  }

  openPaperReport() {
    const modal = this.modalService.open(
      PaperReportComponent,
      { backdrop: 'static', centered: true, keyboard: false, size: 'lg', windowClass: 'paper-report' }
    );
  }

  openPaperCredit() {
    const modal = this.modalService.open(
      PaperCreditComponent,
      { backdrop: 'static', centered: true, keyboard: false, size: 'lg', windowClass: 'paper-credit' }
    );
  }
}
